import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Form, Badge } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import Pagination from "../../helper/Pagination";
import { getLicenses } from "../../redux/actions/settingActions";
import TrackModal from "./TrackModal";

const Setting = () => {
  const dispatch = useDispatch();
  const {
    licenses = [],
    loading = false,
    error = null,
    pagination = {},
  } = useSelector((state) => state.setting || {});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("active");
  const [showModal, setShowModal] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState(null);

  useEffect(() => {
    dispatch(
      getLicenses({
        page: currentPage,
        limit: itemsPerPage,
        search: searchTerm,
        status: statusFilter,
      })
    );
  }, [dispatch, currentPage, itemsPerPage, searchTerm, statusFilter]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    if (value.length === 0 || (value.length > 0 && value[0] !== " ")) {
      setSearchTerm(value);
    } else if (searchTerm.length > 0) {
      setSearchTerm(value);
    }
    setCurrentPage(1);
  };

  const handleRowClick = (license) => {
    setSelectedLicense(license);
    setShowModal(true);
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  return (
    <div className="page-container">
      <div className="page-card scroll-container">
        <div className="form-header">
          <h2>Settings Management</h2>
        </div>
        <div className="table-section">
          <div className="d-flex justify-content-end align-items-center mb-2">
            <div className="d-flex gap-3">
              <div className="position-relative">
                <input
                  type="search"
                  placeholder="Search licenses..."
                  className="form-input"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  style={{ width: "220px" }}
                />
                {searchTerm === "" && (
                  <div
                    className="position-absolute"
                    style={{
                      top: "50%",
                      right: "13px",
                      color: "#666",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <FaSearch />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="table-scroll-wrapper">
            <table className="partners-table">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>License Name</th>
                  <th>License Key</th>
                  <th>Status</th>
                  <th>Partner Assigned</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Created Date</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="9"
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#666",
                      }}
                    >
                      <div className="loading-spinner"></div>
                    </td>
                  </tr>
                ) : licenses.length === 0 ? (
                  <tr>
                    <td
                      colSpan="9"
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#666",
                      }}
                    >
                      No licenses found
                    </td>
                  </tr>
                ) : (
                  licenses.map((license, index) => (
                    <tr key={license._id} onClick={() => handleRowClick(license)} style={{ cursor: "pointer" }}>
                      <td>{index + 1}</td>
                      <td>
                        {license.name
                          ? license.name.length > 20
                            ? license.name.charAt(0).toUpperCase() +
                              license.name.substring(1, 20) +
                              "..."
                            : license.name.charAt(0).toUpperCase() +
                              license.name.slice(1)
                          : "N/A"}
                      </td>
                      <td>{license.licenseKey || "N/A"}</td>
                      <td>
                        <Badge bg={license.status === "active" ? "success" : "danger"}>
                          {license.status || "N/A"}
                        </Badge>
                      </td>
                      <td>
                        <Badge bg={license.partnerAssigned ? "success" : "danger"}>
                          {license.partnerAssigned ? "True" : "False"}
                        </Badge>
                      </td>
                      <td>
                        {license.startDate
                          ? new Date(license.startDate).toLocaleDateString()
                          : "__"}
                      </td>
                      <td>
                        {license.endDate
                          ? new Date(license.endDate).toLocaleDateString()
                          : "__"}
                      </td>
                      <td>
                        {license.createdAt
                          ? new Date(license.createdAt).toLocaleDateString()
                          : "__"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={pagination.totalPages || 1}
            totalItems={pagination.totalItems || 0}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
          />
        </div>

        <TrackModal
          show={showModal}
          onHide={() => setShowModal(false)}
          selectedLicense={selectedLicense}
        />
      </div>
    </div>
  );
};

export default Setting;
